import { render, staticRenderFns } from "./WalletConfig.vue?vue&type=template&id=63772ca4&scoped=true"
import script from "./WalletConfig.vue?vue&type=script&lang=js"
export * from "./WalletConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63772ca4",
  null
  
)

export default component.exports